
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arts-de-table",
      function () {
        return require("private-next-pages/arts-de-table/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/arts-de-table"])
      });
    }
  